"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var STORAGE_DEVICE_ID_KEY = 'CTV_FRAMEWORK_DEVICE_ID';
var ID_LENGTH = 20;
var DeviceInfo = (function () {
    function DeviceInfo(cache) {
        this.cache = cache;
    }
    DeviceInfo.prototype.initialise = function () {
        var _this = this;
        return this.cache.getItem(STORAGE_DEVICE_ID_KEY).then(function (cachedId) { return _this.cacheDeviceId(cachedId); });
    };
    Object.defineProperty(DeviceInfo.prototype, "uniqueDeviceId", {
        get: function () {
            return this.cachedDeviceId;
        },
        set: function (value) {
            this.cachedDeviceId = value;
            this.cache.setItem(STORAGE_DEVICE_ID_KEY, value);
        },
        enumerable: true,
        configurable: true
    });
    DeviceInfo.prototype.cacheDeviceId = function (cachedId) {
        if (!cachedId) {
            this.cachedDeviceId = client_lib_js_player_framework_utils_1.randomString(ID_LENGTH);
            this.cache.setItem(STORAGE_DEVICE_ID_KEY, this.cachedDeviceId);
        }
        else {
            this.cachedDeviceId = cachedId;
        }
        return this.cachedDeviceId;
    };
    return DeviceInfo;
}());
exports.DeviceInfo = DeviceInfo;
